/** @format */

import { Routes, Route, Navigate } from "react-router-dom";
import { useEffect } from "react";
import AdminHome from "../Component/Admin/Dashboard/default/AdminHome";
import DocViewer from "../Component/Dashboard/PLAN01/TabDocs/DocViewer";
import Import from "../Component/Dashboard/Import/Import";
import ModelsVideoCodage from "../Component/Dashboard/Default/VideoCodage/ModelsVideoCodage";
import AdmDocStatus from "../Component/Admin/Dashboard/default/AdmDocStatus/AdmDocStatus";
import MassUpdate from "../Component/Admin/Dashboard/default/AdmMassUpdate/AdmMassUpdate";
import AdmDocId from "../Component/Admin/Dashboard/default/AdmDocId/AdmDocId";
import { checkTokenExpiration } from "./RouterUtils";
import Cookies from "js-cookie";
import DynamicModelRouter from "./DynamicModelRouter";

export default function RouterAdmin() {
  const token = Cookies.get("Token");
  const role = Cookies.get("Role");

  useEffect(() => {
    const interval = setInterval(checkTokenExpiration, 60000);
    return () => clearInterval(interval);
  }, []);

  if (!token || role !== "superadmin") {
    localStorage.clear();
    Object.keys(Cookies.get()).forEach((cookieName) => {
      Cookies.remove(cookieName);
    });
    return <Navigate to="/" replace />;
  }

  return (
      <Routes>
      <Route index element={<AdminHome />} />

      <Route path=":configKey" element={<DynamicModelRouter />} />

      <Route path="DocStatus" element={<AdmDocStatus />} />
      <Route path="MassUpdate" element={<MassUpdate />} />
      <Route path="DocId" element={<AdmDocId />} />
      <Route path="DocView" element={<DocViewer />} />
      <Route path="Import" element={<Import />} />
      <Route path="ModelsVideoCodage" element={<ModelsVideoCodage />} />
      

      <Route path="*" element={<Navigate to="/Admin" replace />} />
      </Routes>
  );
}
